import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { AdminService } from '../services/admin.service';
import { ConstantsService } from '../services/constants.service';
import { DataService } from '../services/data.service';
import { UrlConstants } from '../services/url-constants';
import { environment } from "../../environments/environment"
import { startWith } from 'rxjs/operators';
const APPROVED_CACHE_KEY = 'ApprovedCache'

@Component({
  selector: 'app-admin-approved',
  templateUrl: './admin-approved.component.html',
  styleUrls: ['./admin-approved.component.scss']
})
export class AdminApprovedComponent implements OnInit {
  titleEdit: UntypedFormGroup;
  public isLoading = false;
  public isdisabled = false;
  public isProcessing = false;
  public folderName = this.constants.APPROVED_TXT;
  public currentUrl;
  public currentVideoTitle;
  public curentVideo;
  public currentIndex = 0;
  public videos;
  public animalsActive = false;
  public rainActive = false;
  public snowActive = false;
  public natureActive = false;
  public cityActive = false;
  public nightActive = false;
  public dayActive = false;
  public interiorActive = false;
  public waterActive = false;
  public disableEdit = true;
  public isEditProcessing = false;
  public CurrentNickName = ""
  public currentLocation = ""
  public currentCountry = ""
  public currentVideoName = ""
  public urlPrefix = `${environment.S3_URL_PRFIX}/${this.constants.APPROVED_TXT}`;
  commonKey;
  userName;
  videoName;
  nickname;
  cityLocation;
  country;
  message;
  prevDisable;
  nextDisable;
  skeltonArray;
  p: number = 1;
  videoTitle: any;
  dateRecording: any;
  timeRecording: any;
  convertedDate: number;
  constructor(
    public constants: ConstantsService,
    private adminservice: AdminService,
    private fb: UntypedFormBuilder,
    private dataService: DataService,
    private urlConstants: UrlConstants,
  ) {
    var skelton = [
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG,
      constants.PENDING_SKELTON_IMG
    ]
    this.skeltonArray = skelton;
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.isdisabled = true;
    this.isProcessing = true;
    this.load();
  }
  load = async () => {
    let rejectedVideos
    this.initialiaseTitleFrom()
    const params = [
      { param: '{object}', value: this.constants.GET_LIST },
      { param: '{id1}', value: this.constants.STATUS_TXT.APPROVED_TXT },
      { param: '{id2}', value: this.constants.GET_LIST },
    ];
    rejectedVideos = await this.dataService.getData(this.urlConstants.getUri(this.urlConstants.getList, params))
    rejectedVideos.subscribe(async (data) => {
      this.videos = data["Items"]
      if (data["Items"].length !== 0) {
        this.videos.forEach(element => {
          element.url = `${environment.S3_URL_PRFIX}/${element.videoStatus}/${element.videoName}`
        });
        await this.assignValue(this.videos, this.currentIndex)
        this.isLoading = false;
        this.isProcessing = false;
      }
      else {
        this.isLoading = false;
        this.isProcessing = false;
      }
    })
  }

  assignValue(videos, index) {
    this.currentVideoTitle = videos[index].videoTitle;
    this.curentVideo = videos[index].videoName;
    this.CurrentNickName = videos[index].nickName;
    this.currentLocation = videos[index].cityLocation;
    this.currentCountry = videos[index].country;
    this.currentVideoName = videos[index].videoName;
    this.currentUrl = videos[index].url;
    let id = videos[index].videoName;
    if (videos[index].tag.Animals) {
      this.animalsActive = true;
    }
    if (videos[index].tag.Snow) {
      this.snowActive = true;
    }
    if (videos[index].tag.City) {
      this.cityActive = true;
    }
    if (videos[index].tag.Nature) {
      this.natureActive = true;
    }
    if (videos[index].tag.Rain) {
      this.rainActive = true;
    }
    if (videos[index].tag.Night) {
      this.nightActive = true;
    }
    if (videos[index].tag.Day) {
      this.dayActive = true;
    }
    if (videos[index].tag.Interior) {
      this.interiorActive = true;
    }
    if (videos[index].tag.Water) {
      this.waterActive =  true;
    }
  }

  async onClickUploadToVimeo(event) {
    this.isProcessing = true;
    let clickedVideoList = (this.videos.filter(s => s.videoName === this.curentVideo))
    if (this.curentVideo === "") {
      document.getElementById("error-message").innerHTML = this.constants.SELECT_VIDEO_TXT
      document.getElementById("error-alert").style.display = this.constants.BLOCK_TXT
      this.isProcessing = false
    }
    else {
      const dateStr =  clickedVideoList[0].dateRecording;
      this.convertedDate = Date.parse(dateStr) / 1000;
      document.getElementById(clickedVideoList[0].videoName).style.opacity = '50%'
      this.commonKey = this.constants.VIDEO_COMMON_KEY
      this.videoName = clickedVideoList[0].videoName;
      this.message = clickedVideoList[0].message;
      var nickName = clickedVideoList[0].nickName;
      var cityLocation = clickedVideoList[0].cityLocation;
      var country = clickedVideoList[0].country;
      var emailId = clickedVideoList[0].emailId;
      var dateRecording = clickedVideoList[0].dateRecording;
      var timeRecording = clickedVideoList[0].timeRecording;
      var tag = clickedVideoList[0].tag
      let attributes = [{
        "videoName": this.videoName,
        "commonKey": this.constants.VIDEO_COMMON_KEY,
        "videoStatus": this.constants.STATUS_TXT.UPLOADEDTOVIEO_TXT,
        "lastFolder": this.constants.APPROVED_TXT,
        "message": `${window.location.origin}/share.html?id=`,
        "otherStatus": "uploaded",
        "nickName": nickName,
        "cityLocation": cityLocation,
        "country": country,
        "emailId": emailId,
        "dateRecording":dateRecording,
        "timeRecording": timeRecording,
        "tag": tag
      }]
      this.adminservice.updateSubmit(attributes)
        .then(data => {
          this.curentVideo = '';
          this.isProcessing = false;
          document.getElementById("videoTitle").innerHTML = clickedVideoList[0].videoTitle;
          document.getElementById("message").innerHTML = this.constants.WINDOW_UPLOAD_TXT
          document.getElementById("success-alert").style.display = this.constants.BLOCK_TXT
          document.getElementById(clickedVideoList[0].videoName).style.display = 'none'
          setTimeout(function () {
            document.getElementById("success-alert").style.display = 'none'
          }, 5000);
        })
        .catch(error => {
          if (error.message != this.constants.TIMEOUT_ERROR_TXT) {
            document.getElementById("error-message").innerHTML = this.constants.COULD_NOT_UPLOAD_TXT;
            document.getElementById("error-alert").style.display = this.constants.BLOCK_TXT
            this.isProcessing = false;
            setTimeout(function () {
              document.getElementById("error-alert").style.display = 'none'
            }, 5000);
          }
          else {
            document.getElementById("videoTitle").innerHTML = clickedVideoList[0].videoTitle;
            document.getElementById("message").innerHTML = ` ${this.constants.WINDOW_UPLOAD_TXT}`
            document.getElementById("success-alert").style.display = this.constants.BLOCK_TXT
            document.getElementById(clickedVideoList[0].videoName).style.display = 'none'
            this.isProcessing = false;
            setTimeout(function () {
              document.getElementById("success-alert").style.display = 'none'
            }, 5000);
          }
        })
    }
  }
  Search() {
    if (this.videoTitle === "") {
      this.load();
      this.isLoading = true;
    }
    else {
      this.videos = this.videos.filter(res => {
        return res.videoTitle.toLowerCase().match(this.videoTitle.toLowerCase());
      })
    }
  }
  onclickRow(video) {
    this.makeDisable()
    this.currentIndex = (this.videos.indexOf(video))
    this.currentUrl = video.url
    document.getElementById(`${video.videoName}-title`).style.fontWeight = "600"
    this.currentVideoTitle = video.videoTitle;
    this.curentVideo = video.videoName;
    this.CurrentNickName = video.nickName;
    this.currentLocation = video.cityLocation;
    this.currentCountry = video.country;
    this.currentVideoName = video.videoName;
    this.dateRecording = video.dateRecording;
    this.timeRecording = video.timeRecording;
    if (video.tag.Animals) {
      this.animalsActive = true;
    }
    if (video.tag.Snow) {
      this.snowActive = true;
    }
    if (video.tag.City) {
      this.cityActive = true;
    }
    if (video.tag.Nature) {
      this.natureActive = true;
    }
    if (video.tag.Rain) {
      this.rainActive = true;
    }
    if (video.tag.Night) {
      this.nightActive = true;
    }
    if (video.tag.Day) {
      this.dayActive = true;
    }
    if (video.tag.Interior) {
      this.interiorActive = true;
    }
    if (video.tag.Water){
      this.waterActive = true;
    }
    this.initialiaseTitleFrom();
  }

  makeDisable() {
    this.animalsActive = false;
    this.snowActive = false;
    this.cityActive = false;
    this.natureActive = false;
    this.rainActive = false;
    this.nightActive = false;
    this.dayActive = false;
    this.interiorActive = false;
    this.waterActive = false;
  }

  closeErrorAlert() {
    document.getElementById("error-alert").style.display = this.constants.NONE_TXT
  }
  closeSuccessAlert() {
    document.getElementById("videoTitle").innerHTML = "";
    document.getElementById("success-alert").style.display = this.constants.NONE_TXT
  }

  initialiaseTitleFrom(): void {
    this.titleEdit = this.fb.group({
      nickName: new UntypedFormControl(this.CurrentNickName),
      location: new UntypedFormControl(this.currentLocation),
      country: new UntypedFormControl(this.currentCountry),
      tags: this.fb.group({
        Animals: this.animalsActive,
        Rain: this.rainActive,
        Snow: this.snowActive,
        City: this.cityActive,
        Nature: this.natureActive,
        Night: this.nightActive,
        Day: this.dayActive,
        Interior: this.interiorActive,
        Water : this.waterActive
      }),
    })
  }

  onClickEdit(event) {
    document.getElementById("edit-form").style.display = 'flex'
    document.getElementById("title-container").style.display = this.constants.NONE_TXT
    document.getElementById("tag-container").style.display = this.constants.NONE_TXT
    this.initialiaseTitleFrom()
  }

  onClickCancel(event) {
    document.getElementById("edit-form").style.display = this.constants.NONE_TXT
    document.getElementById("title-container").style.display = 'flex'
    document.getElementById("tag-container").style.display = 'flex'
    this.titleEdit.value.nickName = this.CurrentNickName;
    this.titleEdit.value.location = this.currentLocation;
    this.titleEdit.value.country = this.currentCountry;
    this.initialiaseTitleFrom()
  }

  onClickDone(event) {
    this.isEditProcessing = true
    var updatedNickname = this.titleEdit.value.nickName;
    var updatedLocation = this.titleEdit.value.location;
    var updatedCountry = this.titleEdit.value.country;
    var tags = this.titleEdit.value.tags;
    var updatedTitle;
    var videoName = this.currentVideoName;
    updatedTitle = `${updatedNickname} - ${updatedLocation}, ${updatedCountry}`;
    let attributes = [{
      videoName: videoName,
      commonKey: this.constants.VIDEO_COMMON_KEY,
      updatedNickname: updatedNickname,
      updatedLocation: updatedLocation,
      updatedCountry: updatedCountry,
      updatedTitle: updatedTitle,
      otherStatus: "nameUpdate",
      tags: tags,
    }];
    this.adminservice.EditName(attributes)
      .then(data => {
        this.makeDisable();
        this.adminservice.getVideoList(this.constants.STATUS_TXT.APPROVED_TXT)
        document.getElementById("edit-form").style.display = this.constants.NONE_TXT
        document.getElementById("title-container").style.display = 'flex'
        document.getElementById("tag-container").style.display = 'flex'
        this.isEditProcessing = false;
        this.load()
      })
      .catch(error => {
        this.isEditProcessing = false;
      }
      )
  }
}
